import { Inject } from '@angular/core';
import templateSource from './view.html';
              import { Component } from '@angular/core';

import Wiz from 'src/wiz';
let wiz = new Wiz('/wiz').app('page.signup');
import { OnInit } from '@angular/core';
import { Service } from "src/libs/portal/season/service";

@Component({
    selector: 'wiz-page-signup',
template: templateSource || '',
    styles: [`

/* file: /mnt/data/wiz/project/main/build/src/app/page.signup/view.scss */
:host {
  display: block;
  min-height: 100%;
}

.auth-shell {
  min-height: 100dvh;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 32px 20px;
  background: #ffffff;
  position: relative;
  overflow: hidden;
}

.auth-transition {
  position: absolute;
  inset: 0;
  background: #ffffff;
  opacity: 0;
  pointer-events: none;
  z-index: 8;
  transition: opacity 0.42s ease;
}

.auth-transition--active {
  opacity: 1;
}

.auth-shell__inner {
  width: min(100%, 1120px);
  display: flex;
  justify-content: center;
  position: relative;
  z-index: 4;
}

.auth-panel {
  width: min(100%, 700px);
  padding: 24px 22px 20px;
  border-radius: 28px;
  border: 1px solid rgba(255, 255, 255, 0.8);
  background: rgba(255, 255, 255, 0.78);
  backdrop-filter: blur(14px);
  box-shadow: 0 30px 60px rgba(15, 23, 42, 0.12);
}

.auth-back-link {
  color: #6b7280;
  font-size: 12px;
  font-weight: 600;
}

.auth-panel__brand {
  display: flex;
  align-items: center;
  gap: 14px;
  margin-top: 18px;
}

.auth-panel__logo {
  width: 104px;
  height: auto;
  display: block;
  flex-shrink: 0;
}

.auth-panel__brand-copy {
  display: flex;
  flex-direction: column;
}

.auth-panel__brand-title {
  color: #111827;
  font-size: 18px;
  line-height: 1.1;
  font-weight: 700;
  letter-spacing: -0.04em;
}

.auth-panel__brand-subtitle {
  margin-top: 3px;
  color: #9ca3af;
  font-size: 12px;
}

.auth-panel__header {
  margin-top: 28px;
  text-align: center;
}

.auth-panel__title {
  margin: 0;
  color: #111111;
  font-size: clamp(24px, 3.3vw, 36px);
  line-height: 1.08;
  font-weight: 800;
  letter-spacing: -0.05em;
}

.auth-form {
  width: min(100%, 520px);
  margin: 24px auto 0;
}

.auth-form__row {
  display: flex;
  flex-direction: column;
  border-bottom: 1px solid rgba(209, 213, 219, 0.9);
  background: #ffffff;
}

.auth-form__label {
  padding: 14px 8px 8px;
  color: #c4c7cc;
  font-size: 14px;
  font-weight: 600;
}

.auth-inline-field {
  display: flex;
  align-items: center;
  gap: 10px;
  padding-right: 8px;
}

.auth-form__input {
  width: 100%;
  height: 42px;
  padding: 0 8px 8px;
  border: 0;
  background: #ffffff;
  color: #111827;
  font-size: 16px;
  outline: none;
}

.auth-form__input:-webkit-autofill,
.auth-form__input:-webkit-autofill:hover,
.auth-form__input:-webkit-autofill:focus,
.auth-form__input:-webkit-autofill:active {
  -webkit-text-fill-color: #111827;
  -webkit-box-shadow: 0 0 0 1000px #ffffff inset;
  box-shadow: 0 0 0 1000px #ffffff inset;
  transition: background-color 9999s ease-out 0s;
}

.auth-form__input--inline {
  flex: 1;
}

.auth-form__input::placeholder {
  color: #d1d5db;
}

.auth-inline-button {
  height: 38px;
  padding: 0 14px;
  border-radius: 999px;
  background: rgba(51, 65, 85, 0.08);
  color: #334155;
  font-size: 12px;
  font-weight: 700;
  white-space: nowrap;
}

.auth-inline-button:disabled {
  opacity: 0.5;
}

.auth-feedback {
  padding: 0 8px 12px;
  font-size: 12px;
  font-weight: 600;
}

.auth-feedback--success {
  color: #059669;
}

.auth-feedback--error {
  color: #dc2626;
}

.auth-submit {
  width: 100%;
  height: 52px;
  margin-top: 6px;
  background: #334155;
  color: #ffffff;
  font-size: 18px;
  font-weight: 700;
  letter-spacing: -0.03em;
}

.auth-panel__links {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 18px;
  margin-top: 20px;
  flex-wrap: wrap;
}

.auth-panel__link {
  color: #111111;
  font-size: 14px;
  font-weight: 600;
}

.auth-panel__link--accent {
  font-weight: 700;
}

@media (max-width: 960px) {
  .auth-shell {
    padding: 20px 16px 28px;
  }
  .auth-panel {
    padding: 22px 18px 20px;
  }
  .auth-panel__header {
    margin-top: 24px;
  }
}
@media (max-width: 640px) {
  .auth-shell {
    padding: 16px 14px 24px;
  }
  .auth-panel__brand {
    align-items: flex-start;
  }
  .auth-panel__logo {
    width: 86px;
  }
  .auth-form {
    width: 100%;
    margin-top: 22px;
  }
  .auth-form__label {
    padding-top: 14px;
    font-size: 14px;
  }
  .auth-form__input {
    height: 40px;
    font-size: 15px;
  }
  .auth-inline-field {
    flex-direction: column;
    align-items: stretch;
    gap: 6px;
    padding-right: 0;
  }
  .auth-inline-button {
    align-self: flex-start;
    margin: 0 8px 10px;
  }
  .auth-submit {
    height: 48px;
    font-size: 16px;
  }
}`],
})
export class PageSignupComponent implements OnInit {
    constructor(@Inject( Service) public service: Service) { }

    public isTransitioning: boolean = false;
    public data: any = {
        name: '',
        username: '',
        password: '',
        passwordConfirm: ''
    };

    public usernameChecked: boolean = false;
    public usernameAvailable: boolean = false;
    public checking: boolean = false;
    public submitting: boolean = false;

    public async ngOnInit() {
        await this.service.init();
        let check = await this.service.auth.check();
        if (check) return location.href = "/dashboard";
    }

    public async alert(message: string, status: string = 'error') {
        return await this.service.modal.show({
            title: "",
            message: message,
            cancel: false,
            actionBtn: status,
            action: '확인',
            status: status
        });
    }

    public async goToAccess(mode: 'landing' | 'login' = 'landing') {
        if (this.isTransitioning) return;
        this.isTransitioning = true;
        await this.service.render();

        const path = mode === 'login' ? '/access?mode=login' : '/access';
        window.setTimeout(() => {
            location.href = path;
        }, 300);
    }

    public onUsernameChange() {
        this.usernameChecked = false;
        this.usernameAvailable = false;
    }

    public async checkUsername() {
        const username = this.data.username.trim();
        if (!username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }

        this.checking = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("check_username", { username });

            this.checking = false;

            if (code === 200) {
                this.usernameChecked = true;
                this.usernameAvailable = data.available;
                if (!data.available) {
                    await this.alert("이미 사용 중인 아이디입니다.");
                }
            } else {
                await this.alert(data?.message || "확인 중 오류가 발생했습니다.");
            }
        } catch (e) {
            this.checking = false;
            await this.alert("서버 오류가 발생했습니다. 다시 시도해주세요.");
        }
        await this.service.render();
    }

    public async signup() {
        const name = this.data.name.trim();
        const username = this.data.username.trim();
        const password = this.data.password;
        const passwordConfirm = this.data.passwordConfirm;

        if (!name) {
            await this.alert("이름을 입력해주세요.");
            return;
        }
        if (!username) {
            await this.alert("아이디를 입력해주세요.");
            return;
        }
        if (!this.usernameChecked || !this.usernameAvailable) {
            await this.alert("아이디 중복확인을 해주세요.");
            return;
        }
        if (!password) {
            await this.alert("비밀번호를 입력해주세요.");
            return;
        }
        if (password !== passwordConfirm) {
            await this.alert("비밀번호가 일치하지 않습니다.");
            return;
        }

        this.submitting = true;
        await this.service.render();

        try {
            const { code, data } = await wiz.call("signup", { name, username, password });

            this.submitting = false;

            if (code === 200) {
                await this.alert("회원가입이 완료되었습니다. 로그인해주세요.", "success");
                await this.goToAccess('login');
            } else {
                await this.alert(data?.message || "회원가입에 실패했습니다.");
            }
        } catch (e) {
            this.submitting = false;
            await this.alert("서버 오류가 발생했습니다. 다시 시도해주세요.");
        }
        await this.service.render();
    }
}

export default PageSignupComponent;